import { render, staticRenderFns } from "./display-field-invoice-date-badge.vue?vue&type=template&id=e3b77070&scoped=true&"
import script from "./display-field-invoice-date-badge.vue?vue&type=script&lang=ts&"
export * from "./display-field-invoice-date-badge.vue?vue&type=script&lang=ts&"
import style0 from "./display-field-invoice-date-badge.vue?vue&type=style&index=0&id=e3b77070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b77070",
  null
  
)

export default component.exports